var doQuestions = {
    init : function() {
        xp = 0;
        if (!wayData.hasOwnProperty("questions")) {
            game.states.setState("WORLD");
            return;
        }
        questions.showQuestions();
    },
    update : function(delta) {

    },
    shutDown : function() {

    }
}

